export const BITFA_BASE_URL_DEV = 'https://api-test.lokopay.io'
export const BITFA_BASE_URL_PROD_V12 = 'https://api.lokopay.io'
export const BITFA_BASE_URL_LOCAL = 'http://localhost:8000'

export const BITFA_DASHBOARD_URL_DEV = 'https://dashboard-test.lokocrypto.com'
export const BITFA_DASHBOARD_URL_PROD_V12 = 'https://dashboard.lokocrypto.com'
export const BITFA_DASHBOARD_URL_LOCAL = 'http://localhost:3000'